import { WorkpaperRoleEnum } from '../types/workpaper';

/**
 * Returns true if the user role is greater than or equal to the required role
 * @param userRole
 * @param requiredRole
 * @returns true if user has a required role otherwise false
 */
export function isRequiredRole(userRole: WorkpaperRoleEnum, requiredRole: WorkpaperRoleEnum): boolean {
    const roleHierarchy = [WorkpaperRoleEnum.PREPARER, WorkpaperRoleEnum.REVIEWER, WorkpaperRoleEnum.APPROVER];

    return roleHierarchy.indexOf(userRole) >= roleHierarchy.indexOf(requiredRole);
}
